import { useEffect, useRef, useState } from "react";

const host = process.env.REACT_APP_API_SERVER;
const API = `${host}/api/availability/calendar/google`;

export default function GoogleCalendarTest() {

  const [loading, setLoading] = useState(false);
  const [connected, setConnected] = useState(false);
  const [email, setEmail] = useState("");

  const clientRef = useRef(null);

  useEffect(() => {

    console.log(
      "Tutor Token =>",
      localStorage.getItem("tutor-token")
    );

    const script = document.createElement("script");

    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;

    script.onload = () => {

      clientRef.current =
        window.google.accounts.oauth2.initCodeClient({

          client_id:
            "626365905797-27qlo1u7qtinjjd7br0d58qp666rhpnk.apps.googleusercontent.com",

         scope:
            "openid email profile https://www.googleapis.com/auth/calendar.freebusy",

          ux_mode: "popup",

          callback: async (response) => {

            console.log(
              "Google Response =>",
              response
            );


            if (!response.code) {

              alert(
                "Authorization code not found."
              );

              return;
            }


            try {

              setLoading(true);


              const res = await fetch(
                `${API}/connect`,
                {
                  method: "POST",

                  headers: {
                    "Content-Type":
                      "application/json",

                    "x-auth-token":
                      localStorage.getItem(
                        "tutor-token"
                      ),
                  },

                  body: JSON.stringify({

                    code: response.code

                  }),
                }
              );


              const data = await res.json();


              console.log(
                "CONNECT RESPONSE =>",
                data
              );


              if (data.status) {

                setConnected(true);

                setEmail(
                  data.data?.google_email || ""
                );


                alert(
                  "Google Calendar Connected Successfully"
                );

              } else {

                alert(data.message);

              }


            } catch (err) {

              console.log(err);

              alert(
                "Connection Failed"
              );

            } finally {

              setLoading(false);

            }

          },

        });

    };


    document.body.appendChild(script);


    return () => {

      document.body.removeChild(script);

    };


  }, []);



  const connectGoogle = () => {

    if (!clientRef.current) {

      alert(
        "Google SDK Not Loaded"
      );

      return;

    }


    clientRef.current.requestCode();

  };



  const disconnectGoogle = async () => {

    try {

      setLoading(true);


      const res = await fetch(
        `${API}/disconnect`,
        {

          method: "POST",

          headers: {

            "Content-Type":
              "application/json",

            "x-auth-token":
              localStorage.getItem(
                "tutor-token"
              ),

          },

        }
      );


      const data = await res.json();


      console.log(
        "DISCONNECT RESPONSE =>",
        data
      );


      if (data.status) {

        setConnected(false);

        setEmail("");

        alert(
          "Google Calendar Disconnected Successfully"
        );

      } else {

        alert(data.message);

      }


    } catch(err) {

      console.log(err);

      alert(
        "Disconnect Failed"
      );


    } finally {

      setLoading(false);

    }

  };



  return (

    <div
      style={{
        padding:40,
        fontFamily:"Arial"
      }}
    >

      <h2>
        Google Calendar Integration Test
      </h2>


      <p>
        <strong>Status : </strong>

        {
          connected
          ? "Connected ✅"
          : "Disconnected ❌"
        }

      </p>


      {
        email &&
        <p>
          <strong>Email :</strong> {email}
        </p>
      }


      <div
        style={{
          display:"flex",
          gap:15,
          marginTop:20
        }}
      >

        <button
          onClick={connectGoogle}
          disabled={loading}
          style={{
            padding:"12px 20px",
            cursor:"pointer"
          }}
        >
          {
            loading
            ? "Connecting..."
            : "Connect Google"
          }

        </button>



        <button
          onClick={disconnectGoogle}
          disabled={loading}
          style={{
            padding:"12px 20px",
            cursor:"pointer"
          }}
        >

          {
            loading
            ? "Disconnecting..."
            : "Disconnect Google"
          }

        </button>


      </div>


    </div>

  );

}